import { Head, useForm, Link } from '@inertiajs/react'
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import { FlashMessage } from '@/components/flash-message'
import { InputField } from '@/components/form-field'

interface Supplier {
  id: number
  name: string
  created_at: string
  updated_at: string
}

interface Props {
  supplier: Supplier
  errors?: Record<string, string>
}

export default function Edit({ supplier, errors: initialErrors }: Props) {
  const { data, setData, put, processing, errors } = useForm({
    name: supplier.name || '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/suppliers/${supplier.id}`, {
      preserveScroll: true,
    })
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData('name', e.target.value)
  }

  return (
    <>
      <Head title="Edit Supplier" />
      <div className="space-y-4 pt-4 px-6">
        <div className="flex items-center gap-4">
          <Link href={`/suppliers/${supplier.id}`}>
            <Button variant="ghost" size="icon">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <h1 className="text-3xl font-bold">Edit Supplier</h1>
        </div>
      </div>

      <FlashMessage />

      <div className="p-6">
        <form onSubmit={handleSubmit} className="max-w-2xl space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Basic Information</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <InputField
                name="name"
                label="Name"
                data={data}
                errors={errors}
                onChange={handleInputChange}
                required
              />
            </CardContent>
          </Card>

          <div className="flex justify-end gap-4">
            <Link href={`/suppliers/${supplier.id}`}>
              <Button type="button" variant="outline">
                Cancel
              </Button>
            </Link>
            <Button type="submit" disabled={processing}>
              Update Supplier
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}
